import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { ISportTO } from 'src/app/models/sportHierarchy/transportObjects/sportTO.interface';
import { BaseService } from './base.service';
import { IUser } from 'src/app/models/user/user.interface';
import { IAuthPlayer } from 'src/app/models/user/authPlayer.interface';
import { LoaderService } from '../loader.service';
import { UserActivityService } from '../userActivity.service';
import { NotificationService } from '../notification.service';
import { StorageService } from '../util/storage.service';

@Injectable()
export class UserProviderService extends BaseService {
  constructor(private http: HttpClient,
              protected loaderService: LoaderService,
              protected userActivityService: UserActivityService,
              protected notificationService: NotificationService,
              protected storage: StorageService) {
    super(loaderService, userActivityService, notificationService, storage);
  }

  authPlayer(user: IUser): Observable<IAuthPlayer> {
    const params = new HttpParams();
    const body = JSON.stringify(user);
    const url: string = this.baseUrlWebClientController + 'login';
    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IAuthPlayer),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err));
        return [];
      }),
    );
  }

  playerLogout(token: string): Observable<boolean> {
    const params = new HttpParams();
    const url: string = this.baseUrlWebClientController + 'webPlayerLogout';
    this.httpHeaders.append('SB-Token',  token);
    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as boolean),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, false));
        return [];
      }),
    );
  }
  // FreeBetBalance/';
  // private _getAccountBalance = this._baseUrl + 'AccountBalance/
  getFreeBetBalance(username: string, language: string, currency: string): Observable<number> {
    const params = new HttpParams();
    const url: string = this.baseUrlWebClientController + 'FreeBetBalance/' + username + '/' + language + '/' + currency;

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as number),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        // if (err.status == 401) {
        //     this.showUnauthorize();
        // } else {
        //     this.showErrorMessage();
        // }
        observableThrowError(this.handleError(err));
        return [];
      }),
    );
  }

  getAccountBalance(username: string, language: string, currency: string, userId): Observable<number> {
    const params = new HttpParams();
    const url: string = this.baseUrlWebClientController + 'AccountBalance/' + username + '/' + language + '/' + currency;

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as number),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        // if (err.status == 401) {
        //     this.showUnauthorize();
        // } else {
        //     this.showErrorMessage();
        // }
        observableThrowError(this.handleError(err));
        return [];
      }),
    );
  }
}
